(function () {
  'use strict';

  /* Producttitels volgens de pipe-methode opsplitsen in naam en omschrijving */
  function splitCard(a) {
    if (a.dataset.ilSplit) return;
    var full = (a.textContent || '').trim();
    var parts = full.split(' | ');
    if (parts.length < 2) return;
    a.dataset.ilSplit = '1';
    var meta = [parts[1], parts[3]].filter(function (p) { return p && !/lichtbron/i.test(p); }).join(', ');
    a.textContent = '';
    var n = document.createElement('span');
    n.className = 'il-card-name';
    n.textContent = parts[0];
    a.appendChild(n);
    if (meta) {
      var m = document.createElement('span');
      m.className = 'il-card-meta';
      m.textContent = meta;
      a.appendChild(m);
    }
  }

  function splitProductTitle(h) {
    if (h.dataset.ilSplit) return;
    var full = (h.textContent || '').trim();
    var parts = full.split(' | ');
    if (parts.length < 2) return;
    h.dataset.ilSplit = '1';
    h.textContent = '';
    var n = document.createElement('span');
    n.className = 'il-title-name';
    n.textContent = parts[0];
    var m = document.createElement('span');
    m.className = 'il-title-meta';
    m.textContent = parts.slice(1).join(', ');
    h.appendChild(n);
    h.appendChild(m);
  }

  function run(root) {
    (root || document).querySelectorAll('.card__heading > a').forEach(splitCard);
    (root || document).querySelectorAll('.product__title h1').forEach(splitProductTitle);
  }

  /* Hero: lichtkleur wisselen */
  function initKelvin() {
    document.querySelectorAll('.il-hero').forEach(function (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-ready'); });
      hero.querySelectorAll('[data-il-kelvin]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          hero.dataset.kelvin = btn.dataset.ilKelvin;
          hero.querySelectorAll('[data-il-kelvin]').forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* Producttabs */
  function initTabs() {
    document.querySelectorAll('[data-il-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ilReady) return;
      wrap.dataset.ilReady = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[role="tabpanel"]'));
      var more = wrap.querySelector('[data-il-more]');
      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          panels[j].hidden = !on;
        });
        if (focus) tabs[i].focus();
        if (more) {
          more.href = tabs[i].dataset.url;
          more.textContent = tabs[i].dataset.more;
        }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
        });
      });
      wrap.querySelectorAll('[data-il-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = panels.filter(function (p) { return !p.hidden; })[0];
          var rail = panel && panel.querySelector('.il-rail');
          if (!rail) return;
          rail.scrollBy({ left: rail.clientWidth * 0.9 * Number(btn.dataset.ilScroll), behavior: 'smooth' });
        });
      });
    });
  }

  function init() {
    run(document);
    initKelvin();
    initTabs();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; run(document); initTabs(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
